import React from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'

import { Copyright, GitBookLink } from '@/constants/manifast'

import { Dividing } from '../common/Structure'
import { Exo2Text } from '../common/Text'

const Footer: React.FC = () => {
  const { t } = useTranslation()
  return (
    <footer className="footer flex flex-col items-center justify-center gap-1 py-3 text-xs xl:flex-row xl:gap-6 xl:py-6">
      <Exo2Text variant="tertiary">{Copyright}</Exo2Text>
      <Exo2Text
        as="div"
        variant="tertiary"
        className="flex items-center gap-2 uppercase"
      >
        <NavLink to={GitBookLink.PrivacyPolicy} target="_blank">
          {t('footer.privacyPolicy')}
        </NavLink>
        <Dividing weight="bold" orientation="vertical" className="h-4" />
        <NavLink to={GitBookLink.TermsOfService} target="_blank">
          {t('footer.termsOfService')}
        </NavLink>
        <Dividing weight="bold" orientation="vertical" className="h-4" />
        <NavLink to={GitBookLink.Fee} target="_blank">
          {t('footer.fees')}
        </NavLink>
      </Exo2Text>
    </footer>
  )
}

export default Footer
